import { logger } from '@ninja/utilities/dist/Debug';
export function validate(params) {
    var _a, _b;
    try {
        if (params.code === 'InvalidResponseSchema') {
            (_a = params.validationSchema) === null || _a === void 0 ? void 0 : _a.parse(params.transformedData);
        }
        else {
            (_b = params.validationSchema) === null || _b === void 0 ? void 0 : _b.parse(params.data);
        }
    }
    catch (ex) {
        const zodError = ex;
        const logMethod = params.validationMode === 'Warning' ? logger.warn : logger.error;
        logMethod(params.requestId, '[Ninja][API-Client][Schema-Validation]', Object.assign({ url: params.url, errors: zodError.format() }, {
            originalResponse: logger.level === 'production' ? undefined : params.data,
        }));
    }
}
